import type { IconSvgObject } from './types';

const Clock02Icon: IconSvgObject = [
  ["path", { d: "M5 8.49817H2.5C4.29927 3.74918 9.503 0.998088 14.5396 2.34292C19.904 3.77528 23.0904 9.25924 21.6565 14.5917C20.2227 19.9241 14.7116 23.0858 9.3472 21.6534C5.36419 20.5899 2.58192 17.2928 2 13.4826", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 7.99841V11.9984L14 13.9984", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Clock02Icon;
